<div class="container-visualizacao">
    <div class="row container-options">
        <div class="col-12">
            <button type="button" class="btn btn-primary" (click)="insert()"><i class="fas fa-plus" aria-hidden="true"></i> Nova</button>

            <span class="float-right">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="search()">
                        <i class="fas fa-search" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clear()">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn" [class.btn-light]="!filterCollapse.isFilterDirty" [class.btn-danger]="filterCollapse.isFilterDirty"
                        (click)="filterCollapse.toggleCollapse()">
                        <i class="fas fa-filter" aria-hidden="true"></i>
                        <i [class]="filterCollapse.collapseIcon" aria-hidden="true"></i>
                    </button>
                </div>                
            </span>          
        </div>
    </div>
    <div class="row container-table" #containerTable>
        <div class="col-12">
            <div class="row container-filter">
                <div class="col-12">
                    <sgt-cidade-filter-collapse
                        [filter]="filter"
                        #filterCollapse>
                    </sgt-cidade-filter-collapse>
                </div>
            </div> 
            <div class="row">
                <div class="col-12">
                    <table class="table table-striped table-hover datatables" id="tableCidades">
                        <thead>
                            <tr>
                                <th class="col-options"></th>
                                <th class="col-codigo-ibge">Código IBGE</th>
                                <th class="col-nome">Nome</th>
                                <th class="col-estado text-center">Estado</th>
                                <th class="col-classificacao text-center">Classificação</th>
                            </tr>
                        </thead>
                    </table>                     
                </div>
            </div>
        </div>
    </div>    
</div>